<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	// Formatters
	import { format } from 'svelte-i18n';
	// Design system components
	import { Button, Input } from '@Shelly/shelly-design-system/index';
	//Helpers
	import { getNumberInputConfig } from 'src/helpers/number_input_helpers';
	import { mathNormalize, valueOutOfDecimalRange, valueOutOfRange } from 'src/helpers/utilities';
	import { getSensorIcon } from '../weather_station_helpers';
	//Types
	import type { BLESetting } from './weather_station_ble_settings_config';
	import type { Device } from 'src/types/Device';

	export let device: Device;
	export let config: BLESetting;
	export let settings: Record<string, number>;
	export let loading: boolean = false;

	const dispatch = createEventDispatcher();
	const { min, max, unit } = config;
	const name = config.component.split(':')[0];
	const icon = getSensorIcon(name === 'UV' ? 'uv_index' : name)?.icon || '';
	const infoLabel = $format('min_max_error_description', {
		values: { min: min + unit, max: max + unit },
		default: `Value must be between ${min} and ${max}.`,
	});
	const save = async () => {
		dispatch('send_data', {
			command: config.command,
			parameter: config.parameter,
			value: rawValue,
		});
	};

	let rawValue = device?.[config.parameter] || 0;
	let value = config.formula(rawValue, config.factor);
	let initSettings = false;

	$: if (settings && !initSettings) {
		rawValue = settings?.[config.parameter] ?? 0;
		value = config.formula(rawValue, config.factor);
		initSettings = true;
	}

	$: error = valueOutOfRange(value, min, max)
		? infoLabel
		: valueOutOfDecimalRange(value.toString(), 1 + Math.ceil(Math.log10(1 / config.step)));
</script>

<Input
	aria-label={$format('input_set_value', { default: 'Set value' })}
	{...getNumberInputConfig()}
	size="m"
	class="mb-s"
	{icon}
	{min}
	{max}
	{error}
	disabled={!settings}
	step={config.step}
	info={error ? '' : infoLabel}
	value={value.toString()}
	on:input={(e) => {
		const val = e.target['value'];
		value = val;
		rawValue = mathNormalize(config.applyformula(val, config.factor), config.rawMin, config.rawMax);
	}}
	id="input-aeyjby0"
/>

<Button size="m" width="full" disabled={!settings || error || loading} {loading} on:click={save}>
	{$format('button_save', { default: 'Save' })}
</Button>
